import {
  Avatar,
  Box,
  ExpansionPanel,
  ExpansionPanelSummary,
  Theme,
  Typography,
  makeStyles,
} from '@forgeglobal/design-framework'
import { ExpansionTableRowProps, ExpansionTableStyles, StyleDefaults } from 'isolated-design-library'
import { OrderBookBidAskDetailQuery, TradeIntentType } from 'graphql/bindings/AdminBindings'
import { Routes, openInNewWindow, routeWithBaseName } from 'util/Routes'
import { formatAbbreviatedMoney } from 'util/NumberUtils'
import { getGravatarUrl } from 'util/GravatarUtil'
import React from 'react'
import moment from 'moment'
import startCase from 'lodash/startCase'

const structureConverter: { [key: string]: string } = {
  forward_backed_fund_interest: 'Forward',
  share_backed_fund_interest: 'SPV',
  direct_share_transfer: 'Direct',
}

const useStyles = makeStyles((theme: Theme) => ({
  fullWidth: {
    width: '100%',
  },
  shorterRow: {
    height: theme.spacing(8),
    padding: theme.spacing(0, 2),
  },
  avatarContainer: {
    display: 'inline-flex',
    verticalAlign: 'middle',
    alignItems: 'center',
  },
  avatarName: {
    marginTop: -2,
    marginLeft: theme.spacing(1),
  },
}))

export const BidAskDetailRow: React.FC<ExpansionTableRowProps<
  OrderBookBidAskDetailQuery['opportunities']['data'][0]
>> = props => {
  const { style, columnDefs, data } = props
  const structures = data.trade_intent.acceptable_structures.map(key => structureConverter[key]).join(', ')
  const color = data.type === TradeIntentType.Bid ? StyleDefaults.palette.bid : StyleDefaults.palette.ask
  const bidAskDate = data.trade_intent.date_updated || data.trade_intent.date_created

  const tableStyle = ExpansionTableStyles(columnDefs)
  const classes = useStyles()

  const accountPageUrl = routeWithBaseName(Routes.account)(data.account.id)
  const opportunityPageUrl = routeWithBaseName(Routes.opportunity)(data.id)
  const gravatarUrl = getGravatarUrl(data.account.email || '')

  return (
    <Box pb={1} style={style}>
      <ExpansionPanel onClick={() => openInNewWindow(opportunityPageUrl)}>
        <ExpansionPanelSummary className={classes.shorterRow}>
          <Typography variant="subtitle2" className={classes.fullWidth}>
            <div className={tableStyle.colSpec}>
              <span key={'creator'} className={classes.avatarContainer}>
                <Avatar src={gravatarUrl} onClick={() => openInNewWindow(accountPageUrl)} />
                <span className={classes.avatarName} onClick={() => openInNewWindow(accountPageUrl)}>
                  {data.account.name}
                </span>
              </span>
              <span key={'owner'}>{data.owners?.[0]?.name ?? ''}</span>
              <span key={'sharePrice'} style={{ color }}>
                {formatAbbreviatedMoney(data.trade_intent.share_price)}
              </span>
              <span key={'targetSize'} style={{ color }}>
                {formatAbbreviatedMoney(data.trade_intent.dollar_amount)}
              </span>
              <span key={'status'} style={{ color }}>
                {startCase(data.status)}
              </span>
              <span key={'structure'} style={{ color }}>
                {structures}
              </span>
              <span key={'date'}>{moment(bidAskDate).fromNow()}</span>
            </div>
          </Typography>
        </ExpansionPanelSummary>
      </ExpansionPanel>
    </Box>
  )
}
